type RoomNotFoundProps = {
  message?: string
}

const RoomNotFound: React.FC<RoomNotFoundProps> = ({ message }) => {
  return (
    <div className='flex flex-col items-center justify-center h-full w-full'>
      <div>
        <img src='/images/oge-logo.svg' alt='OGE' className='h-64 w-64' />
      </div>
      <p className='text-3xl text-dark-blue font-black'>
        {message ?? 'Unable to fetch the details.'}
      </p>
    </div>
  )
}

export default RoomNotFound
